module.exports = __webpack_public_path__ + "fonts/a64f4d7.ttf";